import { Box } from '@rbilabs/universal-components';

import { spacing } from 'styles/constants';

const FORM_SPACING = spacing.$4;

export const StyledSaveCardContainer = Box.withConfig({
  paddingX: FORM_SPACING,
  paddingBottom: '$2',
});

export const StyledBillingCityWrapper = Box.withConfig({
  flexBasis: '60%',
  marginRight: '5%',
  marginBottom: FORM_SPACING,
});

export const StyledBillingStateWrapper = Box.withConfig({
  flexBasis: '35%',
  marginBottom: FORM_SPACING,
});

export const StyledStreetAddressWrapper = Box.withConfig({
  flexBasis: '100%',
  marginBottom: FORM_SPACING,
});

export const StyledBillingAptWrapper = Box.withConfig({
  width: 'full',
  flexGrow: 1,
  marginRight: {
    md: '5%',
  },
  marginBottom: FORM_SPACING,
});

export const StyledBillingZipWrapper = Box.withConfig({
  width: 'full',
  marginBottom: FORM_SPACING,
});

export const StyledNameOnCardWrapper = Box.withConfig({
  marginBottom: FORM_SPACING,
});

export const StyledCountrySelectWrapper = Box.withConfig({
  flexBasis: '100%',
  marginBottom: FORM_SPACING,
});

export const DefaultContainer = Box.withConfig({
  width: 'full',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: '$2',
});
